import { render, staticRenderFns } from "./PromocodeUsages.vue?vue&type=template&id=1311f48c&"
import script from "./PromocodeUsages.vue?vue&type=script&lang=js&"
export * from "./PromocodeUsages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports